import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const trackEvent = (event, page = "dashboard", meta = null) => {
  axios.post(`${API}/track`, { event, page, meta }).catch(() => {});
};
